export default {
  common: {
    cancel: "Abbrechen",
    add: "Hinzufügen",
    back: "Zurück", 
    next: "Weiter", 
    submit: "Absenden",
    saving: "Speichern…",
    saved: "Gespeichert ✓",

  },
  menu: {
    backToDashboard: "Zurück zum Dashboard",
    myObjects: "Meine Unterkünfte",
    settings: "Einstellungen",
    help: "Hilfe / Kontakt",
    logout: "Abmelden",
    language: "Deutsch",
  },
  contact: {
    title: "Kontakt",
    subtitle: "Wie können wir dir helfen?",
    messageLabel: "Deine Nachricht",
    send: "Nachricht senden",
    success: "Nachricht wurde gesendet!",
    close: "Schliessen",
  },
  dashboard: {
  welcome: "Willkommen zurück, ",
  overview: "Meine Übersicht",
  summaryText: "Hier findest du eine schnelle Übersicht über den Status deiner Unterkünfte.",
  activeObjects: "Objekt(e) online",
  inReviewObjects: "Objekt(e) in Prüfung",

  contact: "Meine Kontaktdaten",
  editContact: "Bearbeiten",

  settings: "Meine Einstellungen",
  subscription: "Abo",
  subscriptionActive: "Aktiv",
  password: "Passwort",
  changePassword: "Passwort ändern",

  objects: "Meine Unterkünfte",
  objectboxText: "Verfügbarkeiten und Preise eingeben",
  objectboxText2: "Unterkunftsdaten bearbeiten",
  objectbuttonText: "Unterkünfte bearbeiten",

  newObjectContainer: "Neue Unterkunft erfassen",
  newObjectDescription: "Erstelle eine neue Unterkunft oder setze eine begonnene Erfassung fort.",
  continueDraft: "➜ Erfassung fortsetzen",
  newObject: "+ neue Unterkunft erfassen",

  documents: "Dokumente",
  lastInvoice: "Letzte Rechnung",
  openArchive: "Archiv öffnen",
},
contactEdit: {
  title: "Kontaktdaten bearbeiten",
  errorLoading: "Fehler beim Laden der Daten.",
  errorSaving: "Fehler beim Speichern der Daten.",
  confirmLeave: "Möchtest du die Änderungen speichern?",
  salutation: "Anrede",
  selectSalutation: "Bitte Anrede auswählen",
  company: "Firma",
  firstName: "Vorname",
  lastName: "Nachname",
  street: "Strasse",
  houseNumber: "Hausnummer",
  postalCode: "Postleitzahl",
  town: "Stadt/Ort",
  country: "Land",
  selectCountry: "Bitte Land auswählen",
  phone: "Telefonnummer",
  cancel: "Abbrechen",
  save: "Speichern",
  requiredFields: "Bitte fülle alle Pflichtfelder aus.",
},
    registerUser: {
    title: "Kontaktdaten",
    verifiedMessage: "Deine E-Mail wurde erfolgreich verifiziert. Bitte gib jetzt deine Kontaktdaten ein.",

    // Form labels
    salutation: "Anrede",
    selectSalutation: "Bitte Anrede auswählen",
    company: "Firma (optional)",
    firstName: "Vorname",
    lastName: "Nachname",
    street: "Strasse",
    houseNumber: "Hausnummer",
    postalCode: "Postleitzahl",
    town: "Stadt / Ort",
    country: "Land",
    selectCountry: "Bitte Land auswählen",

    // Phone
    phone: "Telefonnummer",
    phonePlaceholder: "Telefonnummer",
    phoneCodePlaceholder: "Vorwahl",
    search: "Suchen...",
    noResults: "Keine Treffer",

    // Legal
    terms: "Ich akzeptiere die",
    termsLink: "AGB",
    privacy: "Ich akzeptiere die",
    privacyLink: "Datenschutzbestimmungen",

    // Buttons
    save: "Daten speichern",

    // Errors
    requiredFields: "Bitte fülle alle Pflichtfelder aus.",
    acceptTerms: "Bitte akzeptiere die AGB und die Datenschutzbestimmungen.",
    loginFirst: "Bitte melde dich zuerst an.",
    errorSaving: "Fehler beim Speichern der Benutzerdaten!",
    errorLoading: "Fehler beim Laden der Daten."
    },
    password: {
    title: "Passwort ändern",
    oldPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Neues Passwort bestätigen",

    cancel: "Abbrechen",
    save: "Speichern",

    errorInvalid: "Bitte fülle alle Felder korrekt aus.",
    errorGeneral: "Fehler beim Passwort ändern.",
    success: "Passwort erfolgreich geändert.",
    confirmLeave: "Möchten Sie die Änderungen speichern?"
},

impressum: {
  title: "Impressum",
  company: "glampingoase GmbH",
  addressLine1: "Breechliweg 3",
  addressLine2: "5102 Rupperswil",
  country: "Schweiz",

  registryNumber: "Handelsregisternummer: CHE-432.303.436",
  registryCourt: "Registergericht: Handelsregisteramt des Kantons Aargau",

  emailLabel: "E-Mail"
},

footer: {
  impressum: "Impressum"
},

objectList: {
  title: "Verfügbarkeiten & Preise verwalten",
  loading: "Lädt...",
  notConfirmed: "noch nicht bestätigt",
  editPrices: "Preise bearbeiten",
  editAvailability: "Verfügbarkeiten bearbeiten",
  noObjectsLine1: "Noch keine Unterkunft erfasst.",
  noObjectsLine2: "Willst du direkt eine anlegen?",
  createObject: "Neue Unterkunft anlegen",
  imageAlt: "Objektbild"
},

prices: {

  openCalendar: "Kalender öffnen",
  datePlaceholder: "tt.mm.jjjj",
  object: "Objekt",

  errorFetchCurrency: "Fehler beim Abrufen der Währung",
  errorFetchObjects: "Fehler beim Laden der Objekte",
  errorFetchObjectName: "Fehler beim Laden des Objektnamens",
  errorFetchSeasons: "Fehler beim Abrufen der Saison-Daten",
  errorFetchSeasonsAlert: "Es gab ein Problem beim Laden der Saison-Daten.",
  errorNotLoggedIn: "Du bist nicht eingeloggt.",
  errorMissingFields: "Bitte fülle alle Felder aus.",
  errorEndBeforeStart: "Das Enddatum darf nicht vor dem Startdatum liegen.",
  errorOverlap: "Diese Saison überschneidet sich mit einer bestehenden Saison.",

  errorSaveSeason: "Fehler beim Speichern der Saison-Daten",
  errorApiRequest: "Fehler bei der API-Anfrage",
  errorSaveSeasonAlert: "Es gab ein Problem beim Speichern der Saison-Daten.",

  confirmDeleteSeason: "Möchtest du die Saison",
  errorDeleteSeason: "Fehler beim Löschen der Saison",
  errorDeleteSeasonAlert: "Die Saison konnte nicht gelöscht werden.",

  errorFinishEditingFirst: "Bitte schliesse die aktuelle Bearbeitung ab, bevor du eine neue Saison hinzufügst.",

  tabPrices: "Preise",
  tabAdditionalCosts: "Nebenkosten",
  tabCurrency: "Währung",
  tabAvailability: "Verfügbarkeit",
  tabObjectList: "Objektübersicht",

  pricesFor: "Preise für",

  hidePastSeasons: "Vergangene Saisons ausblenden",
  showPastSeasons: "Vergangene Saisons einblenden",

  seasonName: "Saisonname",
  pricePerNight: "Preis pro Nacht in",

  saving: "Speichern...",
  cancel: "Abbrechen",
  addSeason: "+ Saison hinzufügen",

infoTitle: "Wie gebe ich Preise ein?",

infoText: "Für jede Saison legst du einen Zeitraum mit Start- und Enddatum fest.\n\nDu kannst der Saison einen beliebigen Namen geben. Dieser dient nur deiner eigenen Übersicht und wird auf der Kundenseite nicht angezeigt.\n\nDer Preis gilt pro Nacht. Achte darauf, dass sich Saisonzeiträume nicht überschneiden. Falls doch, erscheint eine Fehlermeldung.\n\nWenn alle Angaben korrekt sind, bestätigst du die Eingabe über das Häkchen im grünen Feld. Die Saison wird gespeichert und du kannst über '+ Saison hinzufügen' die nächste Saison anlegen.\n\nEs kann immer nur eine Saison gleichzeitig bearbeitet werden, da bei jeder Änderung automatisch auf Überschneidungen geprüft wird.\n\nBereits gespeicherte Saisons kannst du über das Stift-Symbol bearbeiten oder über das Mülleimer-Symbol löschen. Diese Aktionen sind nur möglich, wenn aktuell keine andere Saison bearbeitet wird.\n\nÜber den Button 'Vergangene Saisons einblenden' kannst du frühere Saisons anzeigen. Diese sind nur zur Ansicht gedacht und können nicht mehr bearbeitet werden.",

close: "Schliessen",

selectCurrencyTitle: "Währung auswählen",
selectCurrencyText: "Bitte wähle eine Währung aus, bevor du Preise hinzufügen kannst.",
currencyRequired: "Bitte zuerst eine Währung auswählen.",

},

additionalCosts: {
  title: "Nebenkosten für",
  object: "Objekt",

  add: "Nebenkosten hinzufügen",

  selectType: "Kostenart auswählen",
  selectUnit: "Einheit auswählen",
  pricePlaceholder: "Preis in",

  saving: "Speichern...",
  cancel: "Abbrechen",

  finishEditingFirst: "Bitte beende zuerst die Bearbeitung, bevor du neue Kosten hinzufügst.",
  fillAllFields: "Bitte fülle alle Felder aus.",
  confirmDelete: "Möchtest du diese Kosten wirklich löschen?",

  errorLoadingTypes: "Fehler beim Laden der Kostenarten",
  errorLoadingUnits: "Fehler beim Laden der Einheiten",
  errorLoadingCosts: "Fehler beim Abrufen der Nebenkosten",
  errorSaving: "Fehler beim Speichern",
  errorDeleting: "Fehler beim Löschen",

  },
  currency: {
  title: "Währung für",
  select: "Währung auswählen",
  saving: "Speichern...",
  save: "Währung speichern",
  saved: "Währung erfolgreich gespeichert",
  errorLoadingCurrencies: "Fehler beim Laden der verfügbaren Währungen",
  errorLoadingObjectCurrency: "Fehler beim Laden der Objektwährung",
  errorLoadingObjectName: "Fehler beim Laden des Objektnamens",
  errorSaving: "Fehler beim Speichern der Währung",
  object: "Objekt"
},

availability: {
  // SETTINGS TAB
  settingsTitle: "Einstellungen",
  modeTitle: "Verfügbarkeitsmodus",
  modeIcal: "iCal Synchronisation",
  modeManual: "Manuelle Verfügbarkeiten",

  warningSwitch: "Beim Wechsel des Modus werden bestehende Verfügbarkeiten gelöscht. Fortfahren?",
  saved: "Einstellungen gespeichert.",

  modalTitle: "Wie möchtest du deine Verfügbarkeiten verwalten?",
  modalText: "Bitte wähle eine der beiden Optionen. Du kannst dies später jederzeit ändern.",
  chooseIcal: "iCal Synchronisation",
  chooseManual: "Manuelle Eingabe",

  // GENERAL
  errorLoading: "Fehler beim Laden der Verfügbarkeiten.",
  tabsAriaLabel: "Verfügbarkeit Tabs",

  // TABS
  tabSettings: "Einstellungen",
  tabIcal: "iCal pflegen",
  tabManual: "Verfügbarkeiten eingeben",
  tabPrices: "Preise",
  tabObjectList: "Objektübersicht"
},

availabilityManual: {
  editAvailability: "Verfügbarkeit bearbeiten",
  loadingObject: "Lade Objektinformationen…",

  legendAvailable: "Verfügbar",
  legendDelete: "Löschen",

  savedSuccess: "Verfügbarkeiten erfolgreich gespeichert!",
  savedPartialError: "Einige Verfügbarkeiten konnten nicht gespeichert oder gelöscht werden.",
  errorSaving: "Fehler beim Speichern.",
  errorNoObjectId: "Fehler: Keine Objekt-ID gefunden."
},

availabilityIcal: {
  title: "iCal Import",
  loading: "Lädt…",

  placeholderUrl: "https://example.com/calendar.ics",
  testPreview: "Vorschau testen",
  testing: "Teste…",
  showSynced: "Synchronisierte Daten anschauen",

  save: "Speichern",
  saving: "Speichern...",
  remove: "Entfernen",

  lastSync: "Letzte Synchronisation",
  previewFailed: "Vorschau fehlgeschlagen",
  previewCalendar: "Vorschau (Kalender)",

  prev: "Zurück",
  next: "Vor",

  errorLoading: "Fehler beim Laden der iCal-Daten.",
  errorNoUrl: "Kein iCal-Link angegeben.",
  errorPreview: "Es gab einen Fehler beim Abruf des Links.",
  errorInvalidUrl: "Ungültige URL.",
  errorSaving: "Speichern fehlgeschlagen.",
  errorRemove: "Entfernen fehlgeschlagen",
  removed: "iCal Link entfernt",
  saved: "iCal Link gespeichert. Synchronisation gestartet.",
  errorLoadSynced: "Fehler beim Laden der synchronisierten Daten.",
  errorNoObjectId: "Keine Objekt-ID gefunden."
},


newObjectModal: {
  title: "Begonnene Unterkunft gefunden",
  description:
    "Du hast bereits eine begonnene Unterkunft. Möchtest du weitermachen oder neu beginnen und die bereits erfassten Daten überschreiben?",
  continue: "Weiter mit bestehender Erfassung",
  startNew: "Neu beginnen"
},

object: {
    tabs: [
    "Grunddaten",
    "Räume",
    "Ausstattung/Umgebung",
    "Belegung",
    "Beschreibung",
    "Bilder",
    "Einreichen"
  ],

  step1: {
    title: "Schritt 1: Allgemeine Informationen",

    fields: {
      name: "Objektname",
      street: "Strasse",
      house_number: "Hausnummer",
      postal_code: "Postleitzahl",
      city: "Ort",
      object_type: "Objektart",
      country: "Land",
      region: "Region",
      licence_number: "Lizenznummer"
    },

    select: {
      choose: "Bitte wählen"
    },

    map: {
      info: "Der Marker wird automatisch anhand der eingegebenen Adresse gesetzt. Sollte die Markierung nicht exakt passen, kann der Marker an die korrekte Stelle verschoben werden.",
      reset: "Marker auf eingegebene Adresse zurücksetzen",
      load_error: "Karte kann nicht geladen werden.",
      loading: "Karte wird geladen..."
    },

    geocode: {
      failed: "Geocodierung fehlgeschlagen.",
      missing_fields: "Bitte füllen Sie alle Adressfelder aus und prüfen Sie, ob die Google Maps API geladen ist."
    }
  },

  step2: {
    title: "Schritt 2: Räume & Ausstattung",
    addRoom: "Raum hinzufügen",
    roomCountTitle: "Wie viele Räume hat deine Unterkunft?",
    roomCountDescription: "Gib die Anzahl pro Raumtyp ein. Danach kannst du jeden Raum einzeln bearbeiten.",
    roomCountSharedHint: "Gemeinschaftlich genutzte Räume wie Bad und Küche zählen auch.",
    addAllRooms: "Alle Räume hinzufügen",
    roomType: "Raumtyp",
    amount: "Anzahl",
    select: "Bitte wählen",
    usage: "Nutzung",
    private: "Eigene Nutzung",
    shared: "Gemeinsame Nutzung",
    onlyOneAllowed: "nur 1 erlaubt",
    beds: "Betten",
    addBed: "Bett hinzufügen",
    bedType: "Bettart",
    size: "Grösse",
    sizeWidth: "Breite (cm)",
    sizeLength: "Länge (cm)",
    sizeOptional: "Optional",
  },


 step3: {
    title: "Schritt 3: Ausstattung & Umgebung",
    general: "Allgemeine Ausstattung",
    outdoor: "Ausstattung Aussenbereich",
    environmentAmenities: "Ausstattung Umgebung",
    environmentCards: "Umgebung",
    errorLoading: "Fehler beim Laden der Ausstattung."
},
step4: {
    title: "Schritt 4: Belegung & Kontaktoptionen",

    maxOccupancy: "Maximale Belegung",
    maxPets: "Maximale Anzahl Haustiere",
    minNights: "Mindestaufenthalt",

    selectPlaceholder: "Bitte wählen",

    arrivalDays: "Anreisetage",

    earliestCheckin: "Frühester Check-in",
    latestCheckout: "Spätester Check-out",

    rules: "Regeln",
    partyAllowed: "Partys erlaubt",
    smokingAllowed: "Rauchen erlaubt",
    yes: "Ja",
    no: "Nein",

    contactOptions: "Kontaktoptionen",
    contactHow: "Wie sollen Gäste dich kontaktieren?",
    contactBoth: "Beides",
    contactWebsite: "Webseite",
    contactWebsitePlaceholder: "https://example.com",
    contactEmail: "E-Mail für Kontaktformular",

    invalidEmail: "Bitte eine gültige E-Mail-Adresse eingeben.",
    errorLoadingArrivalDays: "Fehler beim Laden der Anreisetage."
  },
  step5: {
    title: "Schritt 5: Objektbeschreibung",
    activitiesTitle: "Aktivitäten in der Nähe",
    activitiesPlaceholder: "Beschreibe, was in der Nähe deines Objekts zu finden ist.",
    descriptionTitle: "Objektbeschreibung",
    descriptionPlaceholder: "Bitte erfasse einen aussagekräftigen Text, der das Objekt gut beschreibt."
  },
  step6: {
    title: "Schritt 6: Bilder hochladen",

    titleImage: "Titelbild",
    additionalImages: "Weitere Bilder (max. 20)",

    selectOrDragTitle: "Titelbild auswählen oder hierher ziehen",
    dragTitleHere: "Ziehe dein Titelbild hierher",

    selectOrDragAdditional: "Dateien auswählen oder hierher ziehen",
    dragAdditionalHere: "Ziehe hier weitere Bilder hinein",

    uploaded: "Bild hochgeladen",
    uploadedCount: "{n} Bild(er) hochgeladen",

    errorMinSize: "Bild muss mindestens {w}x{h} Pixel haben.",
    errorInvalidFormat: "Ungültiges Bildformat."
  },
  step7: {
    title: "Schritt 7: Abschluss & Abo wählen",
    intro: "Fast geschafft! Wähle jetzt dein Abo-Modell und überprüfe, ob alle Schritte vollständig sind.",

    subscriptionTitle: "Abo-Modell wählen",

    freeTitle: "Free",
    freePrice: "Kostenlos",
    freeDescription: "Platzhalter Text. Hier steht der Text. Platzhalter Text. Hier steht der Text.",

    monthlyTitle: "Monatlich",
    monthlyPrice: "2 CHF / Monat",
    monthlyDescription: "Platzhalter Text. Hier steht der Text. Platzhalter Text. Hier steht der Text.",

    yearlyTitle: "Jährlich",
    yearlyPrice: "20 CHF / Jahr",
    yearlyDescription: "Platzhalter Text. Hier steht der Text. Platzhalter Text. Hier steht der Text.",

    overviewTitle: "Übersicht deiner Angaben",
    fix: "Ergänzen",

    overviewItems: [
      { step: 1, title: "Grunddaten" },
      { step: 2, title: "Räume" },
      { step: 3, title: "Ausstattung/Umgebung" },
      { step: 4, title: "Belegung" },
      { step: 5, title: "Beschreibung" },
      { step: 6, title: "Bilder" }
    ],

    errorUnknown: "Unbekannter Fehler.",
    errorGeneral: "Ein Fehler ist aufgetreten."
  }

}

}